import { INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";
import { PickupPlacement } from "./PickupPlacement";

export class IceBootsPickupPlacement extends PickupPlacement {
  addsItemToInventoryOnCollide(body) {
    if (body.type === PLACEMENT_TYPE_HERO) {
      return INVENTORY.ICE_PICKUP;
    }
    return null;
  }

  canBeStolen() {
    return true;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.ICE_PICKUP} />;
  }
}
